import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import ArrayUtils from 'src/utils/array.utils';
const TransactionReducer = (state = { loading: false, list: [], lastUsedStart: -1, totalCount: 0 }, { type, payload }) => {
    switch (type) {
        case SteemActionType.SET_ACTIVE_ACCOUNT:
            return { loading: true, list: [], lastUsedStart: -1, totalCount: 0 };
        case SteemActionType.INIT_TRANSACTIONS:
            return {
                loading: false,
                list: payload.transactions,
                lastUsedStart: payload.nextStart,
                totalCount: payload.totalCount || 0
            };
        case SteemActionType.ADD_TRANSACTIONS:
            return Object.assign(Object.assign({}, state), { list: ArrayUtils.mergeWithoutDuplicate(state.list, payload.transactions, 'key'), lastUsedStart: payload.nextStart, totalCount: payload.totalCount || state.totalCount });
        default:
            return state;
    }
};
export default TransactionReducer;
